import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { StoreBox, Name, Info, SelectStoreButton, Availability } from './styled'
import setPickupStore from '../../../actions/setPickupStore'

class Store extends Component {
  constructor(props) {
    super(props)
    this.wrapperRef = React.createRef()
  }

  render() {
    const { name, address, id, time, availability, setPickupStore, pickupStore, closeStoreSelector } = this.props
    const isSelected = pickupStore.id === id
    return (
      <StoreBox className="row">
        <div className="col-xs-8 col-9">
          <Name className="col-12">
            <img
              style={{
                width: '23px',
                marginTop: '-5px',
                marginRight: '5px',
              }}
              alt="delivery_store_circle"
              src="/catalogo/images/delivery_store_orange.svg"
            />
            {name}
          </Name>
          <Info className="col-12">{address}</Info>
          <Info className="col-12">{time}</Info>
          <Availability className="col-12">{availability}</Availability>
        </div>
        <div className="col-xs-4 col-3">
          <SelectStoreButton
            className={`${isSelected ? ' selected' : ''}`}
            onClick={(event) => {
              const selectedStore = { id, name, address }
              event.preventDefault()
              localStorage.setItem('BuySmart-selectedPickupStore', JSON.stringify(selectedStore))
              setPickupStore(selectedStore)

              setTimeout(() => {
                closeStoreSelector()
              }, 500)
            }}
            type="button"
          >
            {isSelected ? <i className="zmdi check" /> : <span />}
          </SelectStoreButton>
        </div>
      </StoreBox>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  setPickupStore: (pickupStore) => dispatch(setPickupStore(pickupStore)),
})

const mapStateToProps = (state) => ({
  pickupStore: state.pickupStore,
})

Store.defaultProps = {
  time: '',
  availability: '',
}

Store.propTypes = {
  name: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  time: PropTypes.string,
  availability: PropTypes.string,
  setPickupStore: PropTypes.func.isRequired,
  closeStoreSelector: PropTypes.func.isRequired,
  pickupStore: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(Store)
